// extracted by mini-css-extract-plugin
export default {"container":"AnnualSwitch-module--container--1bb95","switch":"AnnualSwitch-module--switch--e5c73"};